import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FilterService, GridComponent, IFilterUI } from '@syncfusion/ej2-angular-grids';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { DayEndService } from 'src/app/services/DayEnd.service';
import { GeneralService } from 'src/app/services/general.service';
import { PosOpeningCashDrawerService } from 'src/app/services/pos_OpeningCashDrawer.service';
import { UserService } from 'src/app/services/User.service';
import { EActionTypes, EToaster, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { IPOSTerminal } from 'src/app/Shared/Interfaces/IPOSSettings';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';
import Swal from "sweetalert2";
declare var $: any;

@Component({
  selector: 'app-ops-pos-terminals',
  imports: [TopBarComponent, SYNCFUSION_MODULES, ANGULAR_MODULES, LoaderComponent, OperationsComponent, UserPermissionHandlerDirective, TooltipModule],
  templateUrl: './ops-pos-terminals.html',
  providers: [FilterService],
  styleUrl: './ops-pos-terminals.scss'
})
export class OpsPosTerminals implements OnInit, OnDestroy {

  public dropdown?: HTMLElement;
  private destroy$ = new Subject<void>();
  isCollapsed: boolean = true;
  @ViewChild('posTerminalGrid', { static: false }) public posTerminalGrid: GridComponent;
  @ViewChild('modalPosTerminals') private modalPosTerminals: ElementRef;
  activeTab: 'All' | 'Active' | 'InActive' = 'All';
  activeColor: string = '#28a745';
  inactiveColor: string = '#dc3545';
  editRight = false;
  editRightFalseMessage: string;
  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.POSTerminal, Action: EActionTypes.VIEW };
  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.POSTerminal, Action: EActionTypes.CREATE };
  deletePermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.POSTerminal, Action: EActionTypes.DELETE };
  formTerminalName = '';
  formTerminalInActive = false;
  public loaderIcon: Promise<boolean>;
  formPOSTerminalID = 0;
  posTerminalNameExists = false;
  currentTerminalName = '';
  currentInActive = false;
  terminals: IPOSTerminal[] = [];
  marketCurrentDate!: Date;
  userName = '';

  constructor(private posOpeningCashDrawerService: PosOpeningCashDrawerService,
    private generalService: GeneralService,
    private userService: UserService,
    private dayEndService: DayEndService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private sharedHTMLSettings: SharedHTMLSettingsDataService) { }

  ngOnInit(): void {
    this.userName = this.userService.getLoggedInUserName();
    this.getUserPermissionForPOSTerminal();
    this.loadMarketCurrentDate();
    this.getPOSTerminals();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getUserPermissionForPOSTerminal(): void {
    if (this.generalService.UserPermissions != undefined) {
      const userRightsForParts = this.generalService.getUserPermissionsForModule(EUserSecurityFunctionID.POSTerminal);
      this.editRight = userRightsForParts.EditRight;
      this.editRightFalseMessage = this.generalService.EditRightFalseMessage;
    } else {
      this.generalService.userGroupPermissions.pipe(takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          const userRightsForParts = this.generalService.getUserPermissionsForModule(EUserSecurityFunctionID.POSTerminal);
          this.editRight = userRightsForParts.EditRight;
          this.editRightFalseMessage = this.generalService.EditRightFalseMessage;
        },
        error: (error) => { },
      });
    }
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  applyFilter(tab: 'All' | 'Active' | 'InActive'): void {
    this.activeTab = tab;
    const fieldName = 'InActive';
    if (tab !== 'All') {
      const value = (tab == 'InActive') ? true : false;
      (this.posTerminalGrid as GridComponent).filterByColumn(fieldName, 'equal', value);
    } else {
      (this.posTerminalGrid as GridComponent).removeFilteredColsByField(fieldName);
    }
  }

  loadMarketCurrentDate(): void {
    this.generalService.GetMarketCurrentTime().pipe(takeUntil(this.destroy$)).subscribe({
      next: (marketTime: string) => {
        const marketDate = marketTime.split('T')[0];
        this.marketCurrentDate = this.toLocalDate(marketDate);
      },
      error: (err) => {
        console.error("Error fetching market time", err);
      }
    });
  }

  toLocalDate(dateString: string): Date {
    const [y, M, d] = dateString.split('-').map(Number);
    return new Date(y, M - 1, d);
  }

  public created() {
    this.posTerminalGrid.element.querySelectorAll('.e-filterdiv')[1].classList.add('e-hide');
    this.posTerminalGrid.element.querySelectorAll('.e-filterdiv')[2].classList.add('e-hide');
    this.posTerminalGrid.filterSettings = { mode: 'Immediate', immediateModeDelay: 100 };
  }

  dataBound(args) {
    if (this.posTerminalGrid && this.posTerminalGrid.filterModule)
      Object.assign((<any>this.posTerminalGrid.filterModule).filterOperators, { startsWith: 'contains' });
  }

  clickNewTerminal() {
    this.formPOSTerminalID = 0;
    this.formTerminalName = '';
    this.formTerminalInActive = false;
    this.posTerminalNameExists = false;
    this.openModal();
  }

  onTerminalRowSelected(event) {
    if (event.target.dataset && (event.target.dataset.colindex == 0 || event.target.dataset.colindex == 1)) {
      if (!this.editRight) {
        this.toastr.info(EToaster.MsgInfoNoRightToEdit + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleInfo, this.sharedHTMLSettings.ToasterConfig);
      } else {
        this.openModal();
        const data = event.data;
        this.formPOSTerminalID = data.Id;
        this.formTerminalName = data.Name;
        this.formTerminalInActive = data.InActive;
        this.currentTerminalName = data.Name;
        this.currentInActive = data.InActive;
        this.posTerminalNameExists = false;
      }
    }
  }

  openModal() {
    const modal = this.modalPosTerminals.nativeElement;
    if (modal) {
      $(modal).modal('show');
      modal.classList.add('show');
    }
  }

  closeModal() {
    const modal = this.modalPosTerminals.nativeElement;
    if (modal.classList.contains('show')) {
      $(modal).modal('hide');
      setTimeout(() => {
        modal.style.display = 'none';
        modal.classList.remove('show');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
      }, 300);
    }
  }

  validatePartDescriptionExists(event) {
    this.posTerminalNameExists = false;
    if (event.target.value && ((this.formPOSTerminalID != 0 && this.currentTerminalName.toLocaleLowerCase() != event.target.value.toLocaleLowerCase().trim()) || this.formPOSTerminalID == 0)) {
      const existsIndex = this.terminals.findIndex(rec => rec.Name.toLocaleLowerCase().trim() == event.target.value.toLocaleLowerCase().trim());
      if (existsIndex != -1) {
        this.posTerminalNameExists = true;
      }
    }
  }

  clickSavePOSTerminal(): void {
    if ((this.formPOSTerminalID != 0 && (this.currentTerminalName != this.formTerminalName || this.currentInActive != this.formTerminalInActive)) || this.formPOSTerminalID == 0) {
      Swal.fire({
        title: $localize`:@@Confirm:Confirm`,
        text: $localize`:@@ConfirmSaveTerminal:Are you sure you want to save this POS Terminal?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`:@@Yes:Yes`,
        cancelButtonText: $localize`:@@No:No`
      }).then((result) => {
        if (result.isConfirmed) {
          // Only validate if terminal name is changed
          if (
            this.formPOSTerminalID != 0 &&
            this.currentTerminalName.trim().toLowerCase() !==
            this.formTerminalName.trim().toLowerCase()
          ) {
            this.validateTerminalBeforeSave();
          }
          else {
            this.closeModal();
            this.saveDataPOSTerminal();
          }
        }
      });
    }
  }

  validateTerminalBeforeSave(): void {

    const formattedDate = this.datePipe.transform(this.marketCurrentDate, 'yyyy-MM-dd');

    this.loaderIcon = Promise.resolve(true);

    this.dayEndService
      .getDayEndTerminals(this.userName, formattedDate, formattedDate)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any[]) => {

          this.loaderIcon = Promise.resolve(false);

          const terminals = Array.isArray(response) ? response : [];

          const terminalAlreadyUsed = terminals.some(x =>
            x?.Terminal?.trim().toLowerCase() ===
            this.currentTerminalName?.trim().toLowerCase()
          );

          if (terminalAlreadyUsed) {
            Swal.fire({
              title: 'Warning',
              text: 'To change the terminal name, there must be no Opening Cash record for this terminal on the current market date.',
              icon: 'warning'
            });
            this.closeModal();
            return;
          }

          this.closeModal();
          this.saveDataPOSTerminal();

        },
        error: () => {
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error(
            'Unable to validate terminal.',
            EToaster.TitleError,
            this.sharedHTMLSettings.ToasterConfig
          );
        }
      });
  }
  saveDataPOSTerminal() {
    this.loaderIcon = Promise.resolve(true);
    const saveModel: IPOSTerminal = { Id: this.formPOSTerminalID, Name: this.formTerminalName.trim(), InActive: this.formTerminalInActive };
    this.posOpeningCashDrawerService.savePOSTerminal(saveModel).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.loaderIcon = Promise.resolve(false);
        if (response.Success) {
          this.getPOSTerminals();
          this.toastr.success(EToaster.MsgSuccessSave + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
        } else {
          this.toastr.error(EToaster.MsgErrorSave + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorSave + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  deleteRow(model: IPOSTerminal): void {
    if (model.TerminalUsedInOpenCash) {
      Swal.fire({
        title: $localize`:@@Warning:Warning`,
        text: $localize`:@@Warning:You cannot delete this Terminal as there are Open Cash amount records assigned to it.`,
        icon: "warning",
        cancelButtonText: $localize`:@@Ok:Ok`,
      });
    } else {
      Swal.fire({
        title: $localize`:@@Confirm:Confirm`,
        text: $localize`:@@ConfirmDeleteTerminal:Are you sure you want to delete this POS Terminal?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: $localize`:@@Delete:Delete`,
        cancelButtonText: $localize`:@@Cancel:Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletePOSTerminal(model.Id);
        }
      });
    }
  }

  deletePOSTerminal(id: number) {
    this.loaderIcon = Promise.resolve(true);
    this.posOpeningCashDrawerService.deletePOSTerminal(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.loaderIcon = Promise.resolve(false);
        if (response.Success) {
          this.toastr.success(EToaster.MsgSuccessDelete + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
          this.getPOSTerminals();
        } else {
          this.toastr.error(EToaster.MsgErrorDelete + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorDelete + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  getPOSTerminals() {
    this.loaderIcon = Promise.resolve(true);
    this.posOpeningCashDrawerService.getPOSTerminals().pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: IPOSTerminal[]) => {
        this.loaderIcon = Promise.resolve(false);
        if (response) {
          this.terminals = response;
          this.posTerminalGrid.refreshColumns();
          this.activeTab = 'All';
          this.applyFilter(this.activeTab);
          this.created();
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }

}
